import React from "react";
import {Link} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import axios from "axios";
import Swal from "sweetalert2";


class Starline extends React.Component {

    constructor() {


        super();
        this.state = {
            single: "-",
            singlepana: "-",
            doublepana: "-",
            triplepana: "-",
            wallet: "0",
            results:[],
            width_b:"0%",
            width:"0%",
            nav_display:"none",
            transfer_point:"none",
        }


    }

    componentDidMount() {

        var form = new FormData();
        form.append("session", localStorage.getItem("token"));
        form.append("mobile", localStorage.getItem("mobile"));

        axios
            .post(process.env.REACT_APP_URL+"/api2/starline_timings.php?market="+process.env.REACT_APP_STARLINE, form,
            )
            .then((response) => {
                if(response.status === 200){
                    if (response.data.nosession){
                        Swal.fire({
                            toast: true,
                            title: 'Oops...',
                            text: "Session Expired"
                        }).then((e)=>{
                            localStorage.clear()
                            window.location.href = "/login";
                        })
                    }
                    this.setState({
                        results:response.data.data,
                        single:response.data.single,
                        singlepana:response.data.singlepatti,
                        doublepana:response.data.doublepatti,
                        triplepana:response.data.triplepatti,
                    })
                } else if(response.status === 401){
                    //  navigate("/login")
                }
            })
    }


    render() {

        let marketCloseError = ()=>{
            Swal.fire({
                toast: true,
                title: 'Oops...',
                text: "Market Already Closed, Please come again tomorrow"
            })
        }

        return (<>
                <div className="RootView">
                    <div className="RootWidth">

                        <div className="loginDiv">


                            <div className="toolbar">
                                <div>
                                    <img onClick={()=>{window.history.go(-1)}}  src="../images/back.png" style={{padding: "5px"}}/>
                                    <span>Starline Games</span>
                                </div>


                            </div>



                            <div style={{padding:"5px"}}>

                            <div className="gameRateBox">
                                <p className="mainTitle">Game Rate</p>
                                <div className="grid2x2">
                                    <div className="delhi_rate_block">
                                        <p  className="delhi_rate">Single Digit <span>{this.state.single}</span></p>
                                    </div>
                                    <div className="delhi_rate_block">
                                        <p  className="delhi_rate">Single Pana <span>{this.state.singlepana}</span></p>
                                    </div>
                                    <div className="delhi_rate_block">
                                        <p  className="delhi_rate">Double Pana <span>{this.state.doublepana}</span></p>
                                    </div>
                                    <div className="delhi_rate_block">
                                        <p  className="delhi_rate">Triple Pana <span>{this.state.triplepana}</span></p>
                                    </div>
                                </div>
                            </div>

                     
                                {this.state.results &&

                                    this.state.results.map((result) => {
                                        let marketStatus = ""
                                        if(result.is_close === "0") { marketStatus = "Market Closed" } else { marketStatus = "Market Open" }
                                        return (

                                            <div className="market_box" key={result.name}>

                                                <div className="main" style={{alignItems:"center"}}>
                                                   <div style={{display:"flex"}}>
                                                   <img src="../images/clock_big.png" style={{height:"55px", marginRight:"10px"}} />
                                                <div className="inner_market_box" style={{textAlign:"center", width: "100%"}}>
                                                    <span className="market_name">{result.name}</span>
                                                    {result.is_open === "1" ?
                                                        <span className="market_result" style={{fontSize:13, color:"green"}}>Market Running</span>
                                                        :
                                                        <span className="market_result" style={{fontSize:13, color:"red"}}>Market Closed</span>
                                                    }
                                                    
                                                </div>
                                                    </div>
                                                <div className="inner_market_box" style={{alignItems:"center", flexDirection:"row"}}>
                                                <span className="market_result starline-result">{result.result}</span>
                                                    { result.is_open === "1" ?

                                                         <Link to={'/starlineGames'} state={[{market: process.env.REACT_APP_STARLINE, is_open: "1", timing: result.close}]}>
                                                                <div className="dehli_play">
                                                                <img src="../images/starline_play.png" />
                                                                    <span>Play Game</span>
                                                                </div>
                                                            </Link>
                                                                :  <Link >
                                                                <div className="dehli_play">
                                                                <img src="../images/starline_play.png" />
                                                                    <span>Play Game</span>
                                                                </div>
                                                            </Link> }

                                                </div>
                                                </div>
                                                
                                            </div>


                                        )})}

                            </div>

                        </div>


                    </div>
                </div>


            </>
        );
    }

}

export default Starline;
